import axios, { CanceledError } from 'axios';
import MenuStructure from './MenuStructure';

function useMenuProvider(baseUrl: string) {
    async function getMenuItems(): Promise<MenuStructure> {
        let abortController = new AbortController();
        const timeout = setTimeout(() => {
            abortController.abort();
            console.log('getMenuItems aborted');
        }, 2000);

        try {
            const response = await axios.get<MenuStructure>(baseUrl + '/api/common/content/menu',
                { signal: abortController.signal, timeout: 2000 });
            clearTimeout(timeout);

            return response.data;
        } catch (e) {
            clearTimeout(timeout);

            if (!(e instanceof CanceledError)) {
                console.log(e);
            }
            throw e;
        }
    }

    return {
        getMenuItems
    };
}

export default useMenuProvider;
